module.exports = __webpack_public_path__ + "media/images/home-header-m-a5f56505d3fba739dd8473e664770dc9.jpg";